import type { PromotionType } from '@weft/types';
import { PROMOTION_TYPES } from '@weft/types';
import { raiseUnreachable } from '@weft/utils';

export const generatePromotionTitle = (promotionType: PromotionType, amount: number) => {
  switch (promotionType) {
    case PROMOTION_TYPES.FreeTrial:
      return `Free Trial | ${amount} Days`;
    case PROMOTION_TYPES.Credit:
      return `${amount} Credits`;
    case PROMOTION_TYPES.Percentage:
      return `${amount}% Discount`;
    default:
      return raiseUnreachable(promotionType);
  }
};

export const getAmountByType = (promotionType: PromotionType, amount: number) => {
  switch (promotionType) {
    case PROMOTION_TYPES.FreeTrial:
    case PROMOTION_TYPES.Credit:
      return amount;
    case PROMOTION_TYPES.Percentage:
      return amount / 100;
    default:
      return raiseUnreachable(promotionType);
  }
};

export const getCalculationByType = (promotionType: PromotionType, totalInvoiceAmount: number) => {
  switch (promotionType) {
    case PROMOTION_TYPES.FreeTrial:
    case PROMOTION_TYPES.Credit:
      return 1;
    case PROMOTION_TYPES.Percentage:
      return totalInvoiceAmount;
    default:
      return raiseUnreachable(promotionType);
  }
};